import runtime from '../src/runtime/locales/en-US';
import renderer from '../src/renderer/locales/en-US';
export default {
    runtime,
    renderer
};
